import React from "react";
import { IoIosSend } from "react-icons/io";

function ChatFooter({ input, setInput, isLoading, handleSubmit }) {

    const styles = {
        inputContainer: {
            padding: "15px",
            borderTop: "1px solid #e9ecef"
        },
        sendButton: {
            backgroundColor: "#CB2C84",
            borderColor: "#CB2C84"
        }
    };

    return (
        <div style={styles.inputContainer}>
            <form onSubmit={handleSubmit} className="d-flex gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Type your message"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    disabled={isLoading}
                />
                <button type="submit" className="btn btn-primary" style={styles.sendButton} disabled={isLoading}>
                    <IoIosSend />
                </button>
            </form>
        </div>
    );
}

export default ChatFooter;
